<script setup lang="ts">
// MenubarItem
import { useForwardPropsEmits } from 'radix-vue'
import { computed } from 'vue'
import { cn } from '@/lib/utils'

const props = defineProps<{
    class?: string
    inset?: boolean
}>()

const emits = defineEmits<{
    select: [event: Event]
}>()

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
    <div
        v-bind="forwarded"
        :class="
            cn(
                'relative data-[disabled]:pointer-events-none data-[disabled]:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-focus focus-visible:rounded-[2px]',
                inset && 'pl-8',
                props.class,
            )
        "
    >
        <slot />
    </div>
</template>
